import { useState, useEffect } from 'react';

const isIos = /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent);
const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

export const usePWAInstall = () => {
  const [isInstalled, setIsInstalled] = useState(isIos ? isStandalone : true);
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = event => {
      event.preventDefault();
      setInstallPrompt(event);
      if (!isIos) {
        setIsInstalled(false);
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handlePwaButton = () => {
    if (!installPrompt) return;

    installPrompt.prompt();
    installPrompt.userChoice.then(choiceResult => {
      if (choiceResult.outcome === 'accepted') {
        setIsInstalled(true);
      }
      setInstallPrompt(null);
    });
  };

  return { isIos, isInstalled, handlePwaButton };
};
